<div class="card">
  <div class="card-header card-title">
    <h5 class="m-0 p-0" i18n="@@EnergyDistributionChart">Nutzung der Energie in Prozent</h5>
  </div>

  <div id="energy-distribution-chart" class="card-body">
    <div *ngIf="isLoading" class="loading-spinner-container" style="margin-top: 80px;">
      <div class="spinner-border text-primary loading-spinner-md" role="status">
        <span class="visually-hidden-focusable" i18n="@@GeneratingStatisticsHint">Grafik zu Energieverteilung wird generiert</span>
      </div>
    </div>

    <canvas id="energy-distribution-chart-canvas" class="min-height w-100" style="display: block; box-sizing: border-box;"
            [ngStyle]="{'visibility': !isLoading ? 'visible' : 'hidden'}"></canvas>
  </div>
</div>
